import React, { useState } from "react";

import { isEmpty } from "ramda";

import { Table, Pagination, PageLoader } from "clearsense-ui/components";
import NoData from "components/Common/NoData";

import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from "../constants";

const DocumentsTable = ({
  columns,
  rows,
  isLoading,
  openUploadPane,
  debouncedSearchString,
}) => {
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [pageNumber, setPageNumber] = useState(DEFAULT_PAGE_NUMBER);

  const expandedRowRender = record => {
    <Table
      data={record.children}
      expandable={{
        expandedRowRender,
        rowExpandable: record => record.isDir === true,
      }}
    />;
  };

  if (isLoading) {
    return <PageLoader />;
  } else if (!rows?.length && isEmpty(debouncedSearchString)) {
    return (
      <NoData
        entity="archival documents"
        actionLabel="Upload Documents"
        onAction={openUploadPane}
      />
    );
  }

  return (
    <div className="cs-ui-table-background rounded-sm archival-reports__table-wrapper cs-ui-table__hide-checkbox">
      <Table
        fixedHeight
        columnData={columns}
        rowData={columns.length && rows}
        className="h-full"
        expandable={{
          expandedRowRender,
          rowExpandable: record => record.isDir === true,
        }}
        expandIconColumnIndex={0}
      />
      {columns.length > 0 && (
        <Pagination
          showResultsPerPage
          totalRecordsCount={rows.length}
          currentPage={pageNumber}
          setCurrentPage={setPageNumber}
          pageSize={pageSize}
          setPageSize={setPageSize}
          pageSizeOptionsList={Array.from(
            { length: 5 },
            (_, index) => DEFAULT_PAGE_SIZE + index * 5
          )}
          className="px-6 py-2 m-0"
        />
      )}
    </div>
  );
};

export default DocumentsTable;
